<template>
  <div ref="whole_page" class="text-left">
    <div class="vx-row mx-4">
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-5/6 xl:w-3/4 mx-auto">
        <div v-for="(_item, index1) in timeCaptureData" :key="index1" class="mb-3">
          <h2>{{ _item.courseName }}</h2>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div v-for="(_module, index2) in _item.modules" :key="index2">
                <h4>{{ _module.name }}</h4>
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div v-for="(_task, index3) in _module.tasks" :key="index3">
                      <h5>{{ index3 + 1 }}. {{ _task.name }}</h5>
                      <div class="vx-row">
                        <div class="vx-col w-full">
                          <p>How many hours did you spend preparing for the assessment? </p>
                          <p class="mb-2"><small>Selected time:&nbsp;<strong>{{ !_task.timeValue ? "None" : `${_task.timeValue} ${_task.timeValue == 1 ? 'hour' : 'hours'}` }}</strong></small></p>
                          <vue-slider
                            class="w-full mb-5"
                            :tooltip="'none'"
                            v-model="_task.timeValue"
                            :adsorb="true"
                            :min="_task.taskClassificationTypeId == 1 ? _module.sliderMinFormatives : _module.sliderMinSummatives"
                            :max="_task.taskClassificationTypeId == 1 ? _module.sliderMaxFormatives : _module.sliderMaxSummatives"
                            :data-label="'id'"
                            :data-value="'id'"
                            :marks="true"
                          ></vue-slider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <vs-divider v-if="_item.modules.length > 1 && index2 < (_item.modules.length - 1)" />
              </div>
            </div>
          </div>
          <vs-divider v-if="timeCaptureData.length > 1 && index1 < (timeCaptureData.length - 1)" />
          <vs-divider v-if="timeCaptureData.length > 1 && index1 < (timeCaptureData.length - 1)" />
        </div>
        <div v-if="timeCaptureData.length > 0" class="vx-row mt-3">
          <vs-spacer />
          <div class="vx-col">
            <vs-button class="vs-con-loading__container" ref="submitbtn" color="success" type="filled" @click="submit">Submit Times</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
export default {
  components: {
    VueSlider
  },
  data() {
    return {
      timeCaptureData: [],
      model: 5
    };
  },
  computed: {},
  methods: {
    loadData() {
      var self = this;

      self.showLoadingOnElement("whole_page", 1, "material");

      var onSuccess = function (response) {
        var data = response.data;

        data.forEach(_item => {
          _item.modules.forEach(_module => {
            var formativesCount = _module.tasks.filter(x => x.taskClassificationTypeId == 1).length;
            var summativesCount = _module.tasks.filter(x => x.taskClassificationTypeId == 2).length;

            _module.sliderMinFormatives = Math.ceil(_module.formativeHoursRequired/formativesCount);
            _module.sliderMinSummatives = Math.ceil(_module.summativeHoursRequired/summativesCount);
            _module.sliderMaxFormatives = Math.ceil(_module.sliderMinFormatives + (_module.sliderMinFormatives * 50/100));
            _module.sliderMaxSummatives = Math.ceil(_module.sliderMinSummatives + (_module.sliderMinSummatives * 50/100));

            _module.tasks.forEach(_task => {
              _task.timeValue = _task.taskClassificationTypeId == 1 ? _module.sliderMinFormatives : _module.sliderMinSummatives
            });
          });

          self.timeCaptureData.push(_item);
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, "Student/GetStudentDataForTimeCapturing", onSuccess, onFinally);
    },
    submit() {
      var self = this;

      self.showLoadingOnElement("submitbtn", 0.45, "material");

      var tasks = [];
      var data = self.timeCaptureData;

      data.forEach(_item => {
        _item.modules.forEach(_module => {
          var tasksWithTime = _module.tasks.filter(x => x.timeValue != null);
          tasksWithTime.forEach(_task => {
            tasks.push({ taskId: _task.id, time: _task.timeValue });
          });
        });
      });
      
      var onSuccess = response => {
        self.$router.back();
      };
      var onFinally = response => {
        self.$vs.loading.close(self.$refs.submitbtn.$el);
      };

      self.$ajaxPost(self, "Student/TimeCaptureSubmit", tasks, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
    stopLoadingOnElement(element) {
      var self = this;
      self.$vs.loading.close(self.$refs[element].$el);
    },
  },
  mounted() {
    var self = this;
    self.loadData();
  },
};
</script>

<style lang="scss">
</style>
